module.exports = __webpack_public_path__ + "media/recipes/49-8abe3780.png";